const Token = 'HRrVZOWmrNO9AXu4420DfEkFpREwFW0SiE2WiRKF';
export default Token